import React from 'react'
import './Contact.css'

/* Inline SVG icons — no emoji, proper accessible icons */
const PhoneIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
    className="contact__icon-svg" aria-hidden="true">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.64 12a19.79 19.79 0 0 1-3-8.59A2 2 0 0 1 3.59 1.5h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9.1a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21.5 16.5v.42z"/>
  </svg>
)

const MailIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
    className="contact__icon-svg" aria-hidden="true">
    <rect width="20" height="16" x="2" y="4" rx="2"/>
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
  </svg>
)

const MapIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
    className="contact__icon-svg" aria-hidden="true">
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/>
    <circle cx="12" cy="10" r="3"/>
  </svg>
)

const Contact = () => {
  return (
    <section name='Contact' className='contact' aria-label="Contact section">
      <div className="container">

        <div className="contact__header reveal">
          <p className="contact__eyebrow">Get In Touch</p>
          <h2 className="contact__heading">Contact <span className="contact__heading-accent">Us</span></h2>
          <span className="section-line" style={{ margin: '0.75rem auto 0' }} />
        </div>

        <div className="contact__grid">

          {/* Info column */}
          <div className="contact__info reveal reveal-left">

            <div className="contact__info-card">
              <div className="contact__info-items">

                <div className="contact__item">
                  <div className="contact__item-icon">
                    <MapIcon />
                  </div>
                  <div>
                    <p className="contact__item-label">Office Address</p>
                    <p className="contact__item-value">
                      LAXMI PARK C-WING, Shop no.05,<br />
                      Sector no.6, Koparkhairane,<br />
                      Navi Mumbai — 400 709
                    </p>
                  </div>
                </div>

                <div className="contact__item">
                  <div className="contact__item-icon">
                    <PhoneIcon />
                  </div>
                  <div>
                    <p className="contact__item-label">Phone</p>
                    <a href="tel:+918652816746" className="contact__item-value contact__link">
                      +91 865-281-6746
                    </a>
                  </div>
                </div>

                <div className="contact__item">
                  <div className="contact__item-icon">
                    <MailIcon />
                  </div>
                  <div>
                    <p className="contact__item-label">Email</p>
                    <a href="mailto:GetNet.ISP@gmail.com" className="contact__item-value contact__link">
                      GetNet.ISP@gmail.com
                    </a>
                  </div>
                </div>

              </div>

              <a href="tel:+918652816746" className="btn-primary contact__cta">
                <PhoneIcon /> Call Now
              </a>
            </div>

          </div>

          {/* Map column */}
          <div className="contact__map reveal reveal-right">
            <div className="contact__map-wrap">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1885.040878360492!2d73.0051433595019!3d19.104068963595132!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c1b78c99e49b%3A0xac4301bec4ca6e03!2sGET%20NET%20Broadband%20internet%20service%20provider!5e0!3m2!1sen!2sin!4v1694868146179!5m2!1sen!2sin"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="GetNet office location on Google Maps"
              />
            </div>
          </div>

        </div>
      </div>
    </section>
  )
}

export default Contact
